import {
  ButtonArrowState,
  Loader,
  PrimaryButton,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import { interpolate } from 'utilities/interpolate';
import styles from './types.module.scss';

const Fulfil = (props) => {
  const { loading = false, onClick, isBlueHuggg = false } = props;

  const label = isBlueHuggg ? 'voucher' : 'gift card';

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <PrimaryButton
          onClick={onClick}
          data-test-id="button-visit-external"
          label={interpolate(dictionary.openVoucher, '[type]', <>{label}</>)}
          arrow={ButtonArrowState.None}
          loading={loading}
          className={styles.fulfilButton}
        />
      )}
    </>
  );
};

Fulfil.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isBlueHuggg: PropTypes.bool,
};

export default Fulfil;
